const recommeneded_section = document.querySelector('.product-recommendations');
const options = {
  rootMargin: '400px'
};

const observer = new IntersectionObserver(entries => {
  if (entries[0].isIntersecting) {
    observer.unobserve(recommeneded_section);

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          console.error("response was not ok");
          return null;
        }
        return response.text();
      })
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (!recommendations) return; // Stop if no recommendations exist

        if (recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          const swiper_recommended = new window.swiper('.recommendations-slider', {
            slidesPerView: 1.4,
            spaceBetween: 20,
            breakpoints: {
              768: {
                slidesPerView: 3
              },
              992: {
                slidesPerView: 4
              },
            },
            navigation: {
              nextEl: document.querySelector('.recommendations-slider-controls .swiper-button-next'),
              prevEl: document.querySelector('.recommendations-slider-controls .swiper-button-prev'),
            },
            lazy: {
              enabled: true,
              checkInView: false,
              loadOnTransitionStart: true,
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            on: {
              init: () => {
                // Select all product card Swiper containers
                const productSwipers = document.querySelectorAll('.product-recommendations .productCardSwiper');
                productSwipers.forEach(swiperEl => {
                  if (swiperEl.classList.contains('swiper-initialized')) return; // Prevent duplicate initialization

                  new window.swiper(swiperEl, {
                    loop: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                    nested: true,
                    navigation: {
                      nextEl: swiperEl.querySelector('.productCardSwiper-next'),
                      prevEl: swiperEl.querySelector('.productCardSwiper-prev'),
                    },
                    lazy: true,
                    preloadImages: false,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                  });

                  swiperEl.classList.add('swiper-initialized'); // Mark as initialized
                });

                // Initialize reviews.io
                ratingSnippet("ruk_rating_snippet", {
                  store: "kettler",
                  color: "#B59D6C",
                  linebreak: true,
                  usePolaris: true,
                  text: "Reviews"
                });
              }
            }
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
}, options);

observer.observe(recommeneded_section);
